<template>
    <div>
        <div class="smart-main-search-container flex flex-wrap">
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.meterNo" placeholder="请输入电表号"></el-input>
            </div>
            <div class="w-180 mr-10">
                <el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>
            </div>

            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.startDate" value-format="yyyy-MM-dd"
                             placeholder="请选择开始时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <date-picker v-model="searchParams.endDate" value-format="yyyy-MM-dd"
                             placeholder="请选择结束时间"></date-picker>
            </div>
            <div class="w-180 mr-10">
                <dropdown placeholder="请选择抄送结果" v-model="searchParams.status"
                          :data-list="globalData.dayAcountTabStatus"></dropdown>
            </div>
            <div class="flex-1"></div>
            <div class="flex">
                <load-button @on-click="search"></load-button>

            </div>
            <div class="flex">
                <el-button type="primary" @click="exportE" plain>导出数据</el-button>
            </div>

        </div>
        <el-button type="text">集中器在线数量：{{meterReading.onLineCount}}</el-button>
        <el-button type="text">集中器不在线数量：{{meterReading.offLineCount}}</el-button>
        <el-button type="text">上次抄表时间：{{meterReading.readTime}}</el-button>
        <el-button type="text">抄表成功数量：{{meterReading.successCount}}</el-button>
        <el-button type="text">抄表失败数量：{{meterReading.errorCount}}</el-button>
        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
    </div>
</template>
<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import DatePicker from "../../components/DatePicker";

    export default {
        components: {
            DatePicker,
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton
        },
        data() {
            return {
                meterReading: {},
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label: '撤销抄表', fn: this.cancel}
                ],
                labels: [
                    // {prop: 'readingTime', label: '结算日'},
                    {prop: 'createAt', label: '结算时间'},
                    {prop: 'status', label: '结算结果', map: this.globalData.dayAcountTabStatus},
                    {prop: 'userName', label: '用户'},
                    {prop: 'meterNo', label: '表号'},
                    {prop: 'conNo', label: '集中器号'},
                    {prop: 'totalNum', label: '用电量'},
                    {prop: 'totalConsume', label: '用电金额'},
                    {prop: 'totalEndNum', label: '总电量'},
                    {prop: 'phaseTotalNum', label: '阶段总电量'},
                    {prop: 'phaseTotalConsume', label: '阶段总金额'},

                    // {prop: 'intype', label: '操作类型',map:this.globalData.intype},
                ],
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            search(stop) {
                this.searchParams.page = 1
                this.getList(stop)
            },
            toPage(page) {
                this.searchParams.page = page
                this.getList()
            },
            exportE() {
                let url = this.globalData.host + "/smartMeter/export/dayAcountTab?accessToken=" + this.$store.state.LoginUser.accessToken || "";
                for (var i in this.searchParams) {
                    url += "&";
                    url += encodeURIComponent(i) + "=" + encodeURIComponent(this.searchParams[i]);
                }
                this.$http$({method: 'get', url: url}, () => {
                    this.$router.push('/admin/downLoadTask')

                })

                // var isFirst = true;
            },
            getList(callback) {
                this.$http$({method: 'get', url: "/smartMeter/accountTab/meterReader"}, (data) => {
                    callback ? callback() : ''
                    this.meterReading = data
                })

                // if(this.$store.state.LoginUser.gardenId){
                //     this.searchParams.gardenID = this.$store.state.LoginUser.gardenId
                // }
                this.$http$({
                    method: 'get',
                    url: "/smartMeter/accountTab/day",
                    data: this.searchParams,
                    load: 1
                }, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            cancel(obj) {
                this.$fnConfirm('确认撤销该抄表？', () => {

                    this.$http$({method: 'get', url: "/smartMeter/accountTab/day/delete/" + obj.id}, (data) => {
                        this.getList()
                        this.$success('撤销成功！')
                    })
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/admin/DayElectric.vue